import { FormSubmissionData } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { contextFactory } from '@frontend/design-system';

export interface FormSubmissionV2ListItemContextValue {
  submission: FormSubmissionData;
}

export const [FormSubmissionV2ListItemContext, useFormSubmissionV2ListItemContext] =
  contextFactory<FormSubmissionV2ListItemContextValue>();
